import { HandshakeIcon } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import NotFoundSvg from "@/assets/images/not-found.svg";
import { TeamCard } from "@/components/molecules/team_retro_list/TeamCard";
import { AnimatedBackground } from "@/components/organisms/animated_background/AnimatedBackground";
import Navbar from "@/components/organisms/navbar/Navbar";
import { Button } from "@/components/ui/button";
import { useUser } from "@/context/user/UserContext.hook";
import { useReflectionCardStore } from "@/store/useReflectionCardStore";
import { ReflectionCardsShelf } from "@/views/retro_active/components/toolbox/ReflectionCardsShelf";

export const HomeView: React.FC = () => {
  const { user } = useUser();
  const { fetchReflectionCards } = useReflectionCardStore();
  const [reflectionCardsShelfTeamId, setReflectionCardsShelfTeamId] =
    useState<string>();

  const onOpenReflectionCardsShelf = (teamId: string) => {
    fetchReflectionCards(teamId);
    setReflectionCardsShelfTeamId(teamId);
  };

  return (
    <>
      <Navbar />
      <AnimatedBackground
        contentClassName={"flex w-full max-w-6xl justify-center"}
      >
        {user?.teams?.length === 0 && <EmptyState />}

        {user?.teams?.length !== 0 && (
          <div
            className={"flex w-full flex-col gap-4 px-3 py-6 sm:px-6 sm:py-8"}
          >
            {user?.teams?.map((team) => (
              <TeamCard
                key={team.id}
                teamId={team.id}
                teamName={team.name}
                openReflectionCardsShelfClick={() => {
                  onOpenReflectionCardsShelf(team.id);
                }}
              />
            ))}
          </div>
        )}
      </AnimatedBackground>

      {reflectionCardsShelfTeamId && (
        <ReflectionCardsShelf
          teamId={reflectionCardsShelfTeamId}
          onDismiss={() => setReflectionCardsShelfTeamId(undefined)}
        />
      )}
    </>
  );
};

const EmptyState: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className={
        "flex flex-col grow items-center justify-center gap-4 m-8 p-4 bg-card rounded-2xl pointer-events-auto max-w-lg"
      }
    >
      <NotFoundSvg />

      <div className={"flex flex-col justify-center items-center gap-4"}>
        <span className={"text-xl font-bold"}>
          Nie jesteś członkiem żadnego Zespołu!
        </span>
        <span>
          Stwórz nowy zespół lub poczekaj na zaproszenie od innego członka
          retromachiny!
        </span>

        <Button onClick={() => navigate("/team/create")}>
          <HandshakeIcon />
          Stwórz Zespół
        </Button>
      </div>
    </div>
  );
};
